import { LoginResponse } from '../common/models/LoginResponse';
import { Post } from '../util/HttpUtils';
import { ErrorHandler, RequestOptions } from '../common/models/GenericTypes';

export async function Kinde(
  Token: string,
  errorHandler?: ErrorHandler
): Promise<LoginResponse | null> {
  const options: RequestOptions = {
    errorHandler,
  };

  return Post<LoginResponse>('api/Auth/kinde-callback', options, { Token });
}
export async function Impersonate(
  Token: string,
  CheckSum: string,
  errorHandler?: ErrorHandler
): Promise<LoginResponse | null> {
  const options: RequestOptions = {
    errorHandler,
  };

  return Post<LoginResponse>('api/Auth/Impersonate', options, { Token, CheckSum });
}
